/* istanbul ignore file */
import { isArray, isNumber, isEmpty } from 'lodash';
import { toJS } from 'mobx';
import { reportError } from '@elevio/elevio-frontend-utils/dist/diagnostics';

export function validateEmail(email) {
  if (!email) return false;
  const parts = email.split('@');
  return !!(parts.length === 2 && parts[0].length > 0 && parts[1].length > 0);
}

export function requiredFieldIsEmpty(field) {
  return !!(
    (isArray(field) && field.length > 0) ||
    (isNumber(field) && field > 0) ||
    (field && field.length && field.length > 0)
  );
}

export function authQuery(user) {
  const queries = {};

  if (user) {
    if (user.email) queries.user_email = user.email;
    if (user.groups) queries.group = toJS(user.groups).slice();
    if (user.userHash) queries.hash = user.userHash;
    if (user.via) queries.via = user.via;
  }

  const queryArr = Object.keys(queries).map(key => {
    const value = queries[key];
    if (Array.isArray(value)) {
      return value.reduce((acc, val) => {
        const encodedVal = encodeURIComponent(val);
        if (acc.length > 0) return `${acc}&${key}=${encodedVal}`;
        return `${key}=${encodedVal}`;
      }, '');
    }

    return `${key}=${encodeURIComponent(value)}`;
  });
  return queryArr.length > 0 ? `&${queryArr.join('&')}` : '';
}

function minifyFormValues(formFields, form) {
  const fields = formFields.reduce(
    (acc, f) =>
      f.gatekeeperMapped
        ? [...acc, { id: f.id, name: f.name, value: f.response }]
        : acc,
    []
  );
  const { id, type, title } = form;
  return JSON.stringify({ id, type, title, fields });
}

export function trackGatekeeperLoad(
  trackEvent,
  fields,
  form,
  searchKeywords,
  ticketUid,
  suggestions
) {
  trackEvent('ticket_gatekeeper_viewpage', {
    queryTerm: searchKeywords.join(','),
    text: minifyFormValues(fields, form),
    custom_attributes: {
      ticket_uid: ticketUid,
    },
    articleIds: suggestions.map(s => s.id),
  });
  if (!ticketUid) {
    const err = new Error({
      type: 'ticket_gatekeeper_viewpage',
      fields,
      form,
      searchKeywords,
      suggestions,
    });
    reportError('Missing ticket Uid', err);
  }
}

export function trackDeflection(
  trackEvent,
  fields,
  form,
  suggestions,
  searchKeywords,
  ticketUid,
  articleId = {}
) {
  trackEvent('deflection_feedback', {
    articleId,
    articleIds: suggestions.map(s => s.id),
    text: minifyFormValues(fields, form),
    queryTerm: searchKeywords.join(','),
    reaction: isEmpty(articleId) ? 0 : 1,
    custom_attributes: {
      ticket_uid: ticketUid,
    },
  });
  if (!ticketUid) {
    const err = new Error({
      type: 'deflection_feedback',
      fields,
      form,
      searchKeywords,
      suggestions,
      articleId,
    });
    reportError('Missing ticket Uid', err);
  }
}

export function trackSuggestionClick(trackEvent, id, ticketUid) {
  trackEvent('ticket_suggestion_click', {
    event_ctx_id: id,
    custom_attributes: {
      ticket_uid: ticketUid,
    },
  });
  if (!ticketUid) {
    const err = new Error({
      type: 'ticket_suggestion_click',
      id,
    });
    reportError('Missing ticket Uid', err);
  }
}

export function trackTicketSubmit(trackEvent, ticketUid) {
  trackEvent('ticket_submit', {
    custom_attributes: {
      ticket_uid: ticketUid,
    },
  });
  if (!ticketUid) {
    const err = new Error({
      type: 'ticket_submit',
    });
    reportError('Missing ticket Uid', err);
  }
}

export function isStorageSupported() {
  try {
    const key = '__some_random_key_you_are_not_going_to_use__';
    localStorage.setItem(key, key);
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js